import { cn } from "@/lib/utils";

const STYLES = {
  draft: "bg-zinc-100 text-zinc-600 border-zinc-200",
  scheduled: "bg-amber-50 text-amber-700 border-amber-200",
  live: "bg-emerald-50 text-emerald-700 border-emerald-200",
  closed: "bg-red-50 text-red-600 border-red-200",
};

export function StatusChip({ status, className }) {
  const s = STYLES[status] || STYLES.draft;
  return (
    <span
      data-testid={`status-chip-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 border px-2.5 py-1 rounded-sm text-[10px] uppercase tracking-widest font-bold",
        s,
        className
      )}
    >
      {status === "live" && (
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
        </span>
      )}
      {status}
    </span>
  );
}
